// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1MkEI","rotate":"Spinner_rotate__1gzvt"};